import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import Hero from "../../components/layouts/Hero";
import Loading from "../../components/Loading";
import { doc, getDoc } from "firebase/firestore";
import db from "../../firebase";

const MenWear = () => {
  const [loading, setLoading] = useState(false);
  const [menWear, setMenWear] = useState();
  const menRef = doc(db, "Pages", "Men");

  useEffect(() => {
    setLoading(true);
    getDoc(menRef).then((data) => {
      setMenWear(data.data());
      setLoading(false);
    });
  }, []);

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div className="">
          <Header />
          <section className="md:h-screen">
            <Hero
              title={menWear?.H1}
              subTitle={menWear?.subTitle}
              content={menWear?.H2}
              buttonLink={"/contact"}
              buttonText={"Contact Us"}
            />
          </section>
          <section className="w-screen flex justify-center bg-white">
            <div className="flex w-4/5 gap-2 md:gap-5">
              <div className="w-1/3 flex flex-col gap-2 md:gap-5">
                <img
                  src={menWear?.Col1Img1}
                  alt="Madhur Exports Design Images Mens wear"
                  className="hover:scale-105 duration-300"
                />
                <img
                  src={menWear?.Col1Img2}
                  alt="Madhur Exports Design Images Mens wear"
                  className="hover:scale-105 duration-300"
                />
                <img
                  src={menWear?.Col1Img3}
                  alt="Madhur Exports Design Images Mens wear"
                  className="hover:scale-105 duration-300"
                />
                <img
                  src={menWear?.Col1Img4}
                  alt="Madhur Exports Design Images Mens wear"
                  className="hover:scale-105 duration-300"
                />
              </div>
              <div className="w-1/3 flex flex-col gap-2 md:gap-5">
                <img
                  src={menWear?.Col2Img1}
                  alt="Madhur Exports Design Images Mens wear"
                  className="hover:scale-105 duration-300"
                />
                <img
                  src={menWear?.Col2Img2}
                  alt="Madhur Exports Design Images Mens wear"
                  className="hover:scale-105 duration-300"
                />
                <img
                  src={menWear?.Col2Img3}
                  alt="Madhur Exports Design Images Mens wear"
                  className="hover:scale-105 duration-300"
                />
                <img
                  src={menWear?.Col2Img4}
                  alt="Madhur Exports Design Images Mens wear"
                  className="hover:scale-105 duration-300"
                />
              </div>
              <div className="w-1/3 flex flex-col gap-2 md:gap-5">
                <img
                  src={menWear?.Col3Img1}
                  alt="Madhur Exports Design Images Mens wear"
                  className="hover:scale-105 duration-300"
                />
                <img
                  src={menWear?.Col3Img2}
                  alt="Madhur Exports Design Images Mens wear"
                  className="hover:scale-105 duration-300"
                />
                <img
                  src={menWear?.Col3Img3}
                  alt="Madhur Exports Design Images Mens wear"
                  className="hover:scale-105 duration-300"
                />
                <img
                  src={menWear?.Col3Img4}
                  alt="Madhur Exports Design Images Mens wear"
                  className="hover:scale-105 duration-300"
                />
              </div>
            </div>
          </section>
        </div>
      )}
    </div>
  );
};

export default MenWear;
